import React, { useEffect, useState } from "react";
import { useWatchState, useModal } from "@/store";
import { BaseService } from "@/service";
import { DealBtn, Comment } from "@/module";
import { Modal } from "antd";
import { checkResult, second2Date } from "@/common";
import "./style.less";

const NAME = "productInfo";

const App = () => {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[DEMAND_CONTACT = ""]] = useWatchState(["$_DEMAND_CONTACT"]);
    const [feedbackFormModal] = useModal(["feedbackFormV2"]);
    const [[{ title = "产品详情", show, hide, width = 1200, resultId = "" }]] = useWatchState(["modal." + NAME]);

    const [data, setData] = useState({});
    const scopes = data.scopes || [];

    useEffect(() => {
        if (resultId) {
            BaseService.list({
                table: "thtt_chanpin",
                columns: "chanpin_id,name,cover,add_time,detail_desc",
                where: {
                    chanpin_id: resultId,
                    "thtt_chanpin.is_delete": 0
                },
                leftJoin: {
                    table: "thtt_organization",
                    on: "thtt_chanpin.unit = thtt_organization.organization_id",
                    columns: ["name AS unitName", "profile AS unitProfile"]
                },
                process: {
                    name: "scopes",
                    key: "chanpin_id",
                    targetKey: "chanpin_id",
                    params: {
                        table: "thtt_chanpin_scope",
                        leftJoin: {
                            table: "thtt_scope",
                            on: "thtt_chanpin_scope.second_scope_id = thtt_scope.id",
                            columns: ["name AS scopeName"]
                        }
                    }
                }
            }).then(res => {
                if (!checkResult(res)) return
                const data = res.data.result[0] || {};
                setData(data);
            })
        } else setData({})
    }, [resultId])

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
            className="modal-resultInfo"
        >
            <h2>{data.name}</h2>
            <p className="dark-disable">{second2Date(data.add_time)}</p>
            <div className="modal-resultInfo-head p-md border flex child-left-md m-md-t">
                <div className="full child-top-sm">
                    <p><span className="bold">产品单位</span>：{data.unitName}</p>
                </div>
                <div className="full child-top-sm">
                    <p><span className="bold">所属领域</span>：{scopes.map(({ scopeName }) => scopeName).join("、")}</p>
                </div>
            </div>
            <article className="m-md-t">
                <h2 className="modal-resultInfo-title-second">产品描述</h2>
                <div className="m-sm-t" dangerouslySetInnerHTML={{ __html: data.detail_desc }}></div>
            </article>
            <article className="m-md-t">
                <h2 className="modal-resultInfo-title-second">单位简介</h2>
                <div className="m-sm-t" dangerouslySetInnerHTML={{ __html: data.unitProfile }}></div>
            </article>
            <article className="m-md-t">
                <h2 className="modal-resultInfo-title-second">联系我们</h2>
                <div className="m-sm-t" dangerouslySetInnerHTML={{ __html: DEMAND_CONTACT }}></div>
            </article>

            <article className="m-md-t">
                <h2 className="modal-resultInfo-title-second">留言</h2>
                <Comment className="m-sm-t" itemId={resultId} type={2} />
            </article>

            <DealBtn className="modal-info-del bor-ra-xs" feebackProps={{ itemId: resultId, itemType: 1 }} />
        </Modal>
    );
}

export default App;